module.exports = __webpack_public_path__ + "assets/white-logo-ec59fa.svg";